import { useEffect } from "react"
import { PropTypes } from "prop-types"
import { scroller, Element } from "react-scroll"

export function ScrollTo(props) {
  const { children } = props

  useEffect(() => {
    scroller.scrollTo("scroll-to", { smooth: true })
  }, [])

  return <Element name="scroll-to">{children}</Element>
}

ScrollTo.propTypes = {
  children: PropTypes.node
}

export default ScrollTo
